import { render } from "./InternalLink.vue?vue&type=template&id=79d66610&scoped=true"
import script from "./InternalLink.vue?vue&type=script&lang=js"
export * from "./InternalLink.vue?vue&type=script&lang=js"

import "./InternalLink.vue?vue&type=style&index=0&id=79d66610&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d66610"]])

export default __exports__